const moment = require('moment-timezone')
// ENVIRONMENT VARIABLES
const IP_URL = process.env.REACT_APP_IP_URL
const PORT = process.env.REACT_APP_PORT
const PROTOCOL = process.env.REACT_APP_PROTOCOL

function create_row(app_state_id, equipment_id, equipment, reason_id, reason, start_date, created_at, time_category, current_status, current_reason, category_name, request_id) {
  let row = {app_state_id, equipment_id, equipment, reason_id, reason, start_date, created_at, time_category, current_status, current_reason, category_name, request_id}
  console.log(`row validation. Start date: ${row.start_date}, created at: ${row.created_at}`)
  return row
} 

async function fetchStates() {
  
  try {
    console.log('get_states')
    const response = await fetch(`${PROTOCOL}://${IP_URL}:${PORT}/mobile_states`, {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": '*'
      }
    })
    const data = await response.json()
    let rows = []
    if (data.status === 200) {
      data.data.map( state => {
        console.log('state full lookin for category name', state)
        const timestamp_start = state.start_date
        const start_date = moment.utc(timestamp_start).format('HH:mm DD-MMM-YYYY ')
        const timestamp_created = state.created_at
        const created_at = moment.utc(timestamp_created).format('HH:mm DD-MMM-YYYY ')
        let row = create_row(state.id_app_state, state.equipment_id, state.equipment_name, state.reason_id, state.reason_name, start_date, created_at, state.time_category_name, state.current_status, state.current_reason, state.category_name, state.request_id)
        rows.push(row)

      })
      return {
        mesagge: 'Success',
        data: rows,
        status: 200
      }
    }
    return {
      mesagge: 'No data retrived',
      status: 400
    }
  } catch (error) {
    return {
      mesagge: error.mesagge,
      status: 500
    }
  }

}

export default fetchStates